import React from 'react';
import * as XLSX from 'xlsx';

const BillOfMaterial = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const bom = inspectionData.BOM;

  if (!bom) {
    return <p className="text-gray-500">No Bill of Materials data available</p>;
  }

  // Define all possible fields across BOM sub-sections
  const allFields = [
    'lotNo',
    'make',
    'model',
    'manufacturingDate',
    'expiryMonitoring',
    'remarks',
    'size',
    'type',
    'efficiency',
    'wattPeak',
    'cableCrossSectionLength',
    'diodeNo',
    'ipRating',
    'jbLipHeight',
    'manufacturingDateA',
    'manufacturingDateB',
    'expiryMonitoringA',
    'expiryMonitoringB',
  ];

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet (Section + all possible fields)
    worksheetData.push(['Section', ...allFields.map((field) => field.replace(/([A-Z])/g, ' $1').trim())]);

    // Populate data for each BOM section
    Object.entries(bom).forEach(([sectionKey, sectionData]) => {
      const row = [sectionKey];
      allFields.forEach((field) => {
        row.push(sectionData[field] || 'N/A');
      });
      worksheetData.push(row);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'BillOfMaterial');
    XLSX.writeFile(workbook, 'BillOfMaterialData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Bill of Materials</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(bom).map(([sectionKey, sectionData]) => {
        // Determine which fields are present in this section
        const presentFields = allFields.filter((field) => sectionData[field] !== undefined);

        return (
          <div key={sectionKey} className="border-b pb-4">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              {sectionKey.replace(/([A-Z])/g, ' $1').trim()}
            </h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    {presentFields.map((field) => (
                      <th key={field} className="px-4 py-2 text-left text-gray-700">
                        {field.replace(/([A-Z])/g, ' $1').trim()}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    {presentFields.map((field) => (
                      <td key={field} className="px-4 py-2 text-gray-600">
                        {sectionData[field] || 'N/A'}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BillOfMaterial;